export { default } from "./removeSuffix";
